// inject the api definitions
export default ({ app }, inject) => {
  inject('platform', 'pos')
}
